<template>
  <div
    class="teacher-course-detail"
    :class="{
      'electron-teacher-course-detail': isElectron,
    }"
    v-loading.fullscreen.lock="pageLoading"
    element-loading-text="进入教室中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255,255,.6)"
  >
    <el-breadcrumb v-if="!isElectron" separator="/">
      <el-breadcrumb-item :to="{ name: 'TCourses' }">课程</el-breadcrumb-item>
      <el-breadcrumb-item>课程详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-cont-wrap">
      <!-- 课程信息 -->
      <div class="course-crad">
        <div class="cover-wrap">
          <img
            v-if="courseInfo.cover_url"
            class="cover"
            :src="processImageUrl(courseInfo.cover_url, 640)"
            alt=""
          />
        </div>
        <div class="course-info">
          <div class="info-top">
            <div class="name-wrap">
              <p class="name">
                {{ courseInfo.course_name }}
              </p>
              <el-popover
                v-model="isShowShare"
                trigger="click"
                placement="bottom-start"
                popper-class="share-popover"
                @after-leave="selectShare = {}"
                @show="onShowSharePopover"
              >
                <button
                  slot="reference"
                  class="share-icon"
                  v-preventReClick
                  v-if="!isWeChat && !isQQ"
                >
                  <img src="../../../assets/images/share-icon.png" alt="" />
                </button>
                <div class="share-box">
                  <div class="share-list" v-if="!selectShare.type">
                    <div
                      class="share-item copy-item"
                      @click="handleCopyPageUrl"
                    >
                      <img
                        src="../../../assets/images/product-details/link.png"
                        alt=""
                      />
                      <span>复制链接</span>
                    </div>
                    <div class="divider"></div>
                    <div class="share-item" @click="handleShare('wechat')">
                      <img
                        src="../../../assets/images/product-details/wx.png"
                        alt=""
                      />
                      <span>微信</span>
                    </div>
                    <div class="share-item" @click="handleShare('circle')">
                      <img
                        src="../../../assets/images/product-details/wx-circle.png"
                        alt=""
                      />
                      <span>朋友圈</span>
                    </div>
                    <div class="share-item" @click="handleShare('QQ')">
                      <img
                        src="../../../assets/images/product-details/QQ.png"
                        alt=""
                      />
                      <span>QQ</span>
                    </div>
                    <div class="share-item" @click="handleShare('space')">
                      <img
                        src="../../../assets/images/product-details/QQ-space.png"
                        alt=""
                      />
                      <span>QQ空间</span>
                    </div>
                    <div class="share-item" @click="handleShare('weibo')">
                      <img
                        src="../../../assets/images/product-details/weibo.png"
                        alt=""
                      />
                      <span>微博</span>
                    </div>
                    <div
                      class="share-item"
                      @click="handleShare('xhs')"
                      v-if="isH5"
                    >
                      <img
                        src="../../../assets/images/product-details/xhs.png"
                        alt=""
                      />
                      <span>小红书</span>
                    </div>
                  </div>
                  <div class="share-content" v-else>
                    <div class="title">
                      <img
                        src="../../../assets/images/product-details/back.png"
                        alt=""
                        @click="handleShareBack"
                      />
                      <span>分享到{{ selectShare.title }}</span>
                    </div>
                    <div class="qrcode-box">
                      <create-qr-code
                        ref="qrCode"
                        :url="courseDetailUrl"
                        :logo-url="logoUrl"
                        :canvas-width="140"
                        :canvas-height="140"
                      />
                    </div>
                    <div class="tips">{{ selectShare.content }}</div>
                  </div>
                </div>
              </el-popover>
            </div>
            <p class="lesson-num">
              课时数<span>{{ courseInfo.lessonNum }}</span>
            </p>
          </div>
          <button @click="createRoom" class="create-room-btn">立即直播</button>
        </div>
      </div>
      <hr class="separator-hr" />
      <ul class="tabs-wrap">
        <li
          @click="activeName = item.key"
          v-for="item in tabList"
          :key="item.key"
          :class="{ active: item.key === activeName }"
        >
          {{ item.name }}
        </li>
      </ul>
      <!-- 单元信息 -->
      <div class="lesson-list-wrap" v-if="activeName === 'course'">
        <LessonList
          v-if="courseInfo.unit_list && courseInfo.unit_list.length"
          :isRegistered="courseInfo.enrollment !== null"
          :unitList="courseInfo.unit_list"
        />
        <el-empty
          v-else
          description="暂无内容"
          :image="require('@/assets/img/live-list/empty.png')"
        ></el-empty>
      </div>

      <!-- 文件 -->
      <file v-if="activeName === 'file'"></file>
      <!-- 私教课 -->
      <lesson-list
        v-if="activeName === 'private'"
        :isRegistered="courseInfo.enrollment !== null"
        :unitList="courseInfo.private_unit_list || []"
      />
    </div>
    <!-- 创建直播课时 -->
    <Dialog
      class="create-room-dialog"
      title="创建直播课时"
      :show="createRoomVisible"
      @cancel="handleCancel"
    >
      <template v-slot:content>
        <el-form ref="form" :model="form" class="lesson-form" :rules="rules">
          <el-form-item label="课时名称" prop="lesson_name">
            <el-input
              v-model.trim="form.lesson_name"
              maxLength="20"
              placeholder="最长 20 个字符"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="直播时长"
            prop="live_duration"
            class="duration-item"
          >
            <el-select
              v-model="form.live_duration"
              placeholder="请选择直播时长"
            >
              <el-option
                v-for="item in durationOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <button @click="handleCancel" class="cancel-btn">取消</button>
          <button @click="submitForm" class="submit-btn">下一步</button>
        </div>
      </template>
    </Dialog>
    <!-- 直播模式 -->
    <!-- @createRooming="createRooming" -->
    <LiveModeDialog ref="liveMode" @success="handleSuccess" />
    <live-overview ref="liveOverview" />
    <poster
      ref="poster"
      :course-info="courseInfo"
      @getPosterUrl="getPosterUrl"
    />
  </div>
</template>

<script>
import { getTeacherToken } from "@saas/service-api/src/live-list";
import LiveModeDialog from "@saas/pages/src/teacher/live-list/components/LiveModeDialog.vue";
import LiveOverview from "@saas/pages/src/teacher/live-list/components/LiveOverview.vue";
import { mapGetters } from "vuex";
import {
  createLesson,
  createUnit,
  checkLiveTime,
} from "@saas/service-api/src/teacher";
import {
  Dialog,
  getNextFiveMinutes,
  joinLiveRoom,
  processImageUrl,
} from "@saas/components/src";
import LessonList from "@saas/pages/src/product-details/lesson-list/LessonList.vue";
import File from "@saas/pages/src/learning-center/course-detail/components/File.vue";
import moment from "moment";
import handleCourseInfo from "@saas/components/src/mixins/handleCourseInfo";
import { getCourseInfo } from "@saas/service-api/src/product-details";
import { copyPageUrl, clipboard } from "@saas/components/src";
import CreateQrCode from "@saas/components/src/components/CreateQrCode";
import Poster from "@saas/components/src/components/Poster";
import shareSdk from "@saas/components/src/utils/share";
import { isH5, isWeChat, isQQ } from "@saas/components/src";
import courseQuickBar from "@saas/components/src/mixins/courseQuickBar";
import { checkPermission } from "@saas/components/src/utils/permission";

export default {
  mixins: [handleCourseInfo, courseQuickBar],
  data: function () {
    return {
      course_id: "",
      courseInfo: {},
      pageLoading: false,
      activeName: "course",
      tabList: [
        { name: "课程列表", key: "course" },
        { name: "文件", key: "file" },
      ],
      createRoomVisible: false,
      form: {
        lesson_name: "",
        live_duration: 60,
      },
      durationOptions: [
        { label: "0.5小时", value: 30 },
        { label: "1小时", value: 60 },
        { label: "1.5小时", value: 90 },
        { label: "2小时", value: 120 },
        { label: "2.5小时", value: 150 },
        { label: "3小时", value: 180 },
        { label: "3.5小时", value: 210 },
        { label: "4小时", value: 240 },
      ],
      rules: {
        lesson_name: [
          { required: true, message: "请输入 1-20 个字符", trigger: "blur" },
        ],
        live_duration: [
          { required: true, message: "请选择直播时长", trigger: "change" },
        ],
      },
      haveWillBeginLesson: false,
      copyPageUrl,
      isElectron: window.isElectron,
      selectShare: {
        type: "",
      },
      courseDetailUrl:
        process.env.VUE_APP_SAAS_WEB_URL +
        "/product-detail/" +
        this.$route.params.id,
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      isShowShare: false,
      isH5: isH5(),
      qrCodeUrl: "",
      posterUrl: "",
      isWeChat: isWeChat(),
      isQQ: isQQ(),
    };
  },
  created() {
    this.course_id = this.$route.params.id;
    this.apiGetCourseInfo();
    if (window.isElectron) {
      // window.ipcRenderer.on("join-live-room-over", this.stopLoading);
      window.ipcRenderer.on("end-class", this.onEndClass);
    } else {
      // window.addEventListener("join-live-room-over", this.stopLoading, true);
    }
  },
  beforeDestroy() {
    // window.removeEventListener("join-live-room-over", this.stopLoading, true);
    // window?.ipcRenderer?.removeListener(
    //   "join-live-room-over",
    //   this.stopLoading
    // );
    window?.ipcRenderer?.removeListener("end-class", this.onEndClass);
  },
  mounted() {
    this.$nextTick(() => {
      // this.$refs.poster.createPoster();
    });
  },
  methods: {
    processImageUrl,
    havePrivateLesson() {
      let length = this.courseInfo?.private_unit_list?.length;
      let data = this.tabList.find((tab) => {
        return tab.key === "private";
      });
      if (!data && length) {
        this.tabList.splice(1, 0, { name: "私教课", key: "private" });
      }
      return length;
    },
    getQrCodeUrl(url) {
      this.qrCodeUrl = url;
    },
    getPosterUrl(url) {
      this.posterUrl = url;
    },
    handleCopyPageUrl() {
      if (window.isElectron) {
        // let content = `${process.env.VUE_APP_SAAS_WEB_URL}/t-course-detail/${this.course_id}`;
        clipboard(this.courseDetailUrl, () => {
          this.$showToast("已复制课程链接，粘贴即可分享");
        });
      } else {
        copyPageUrl("", this.courseDetailUrl);
      }
    },
    handleShare(type) {
      console.log(this.posterUrl);
      if (type === "wechat") {
        this.selectShare = {
          type: "wechat",
          title: "微信",
          content: "扫描二维码，将课程分享给微信好友吧。",
        };
      } else if (type === "QQ") {
        this.selectShare = {
          type: "QQ",
          title: "QQ",
          content: "扫描二维码，将课程分享给QQ好友吧。",
        };
      } else if (type === "space") {
        this.selectShare = {
          type: "space",
          title: "QQ空间",
          content: "扫描二维码，将课程分享到QQ空间吧。",
        };
      } else if (type === "circle") {
        this.selectShare = {
          type: "circle",
          title: "朋友圈",
          content: "扫描二维码，将课程分享到朋友圈吧。",
        };
      } else if (type === "weibo") {
        shareSdk("weibo", {
          url: this.courseDetailUrl, // 分享地址
          title: this.courseInfo.course_name, // 分享标题
          pic: this.courseInfo.cover_url,
        });
      } else if (type === "xhs") {
        if (!this.posterUrl) {
          this.$message.error("海报正在生成中，请稍后重试");
          return;
        }
        shareSdk("xhs", {
          shareInfo: {
            type: "normal", // 必填，笔记类型 'video' | 'normal'
            // title: "测试标题", // 笔记标题
            content: `速看！这门内容充实，讲解精彩的课程【${this.courseInfo.course_name}】，可别错过了！扫描二维码，魔果云课看好课！`, // 笔记正文
            images: [this.posterUrl], // 图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文
          },
          fail: (e) => {
            console.log(e);
            // 调用失败时执行的回调函数
          },
        });
      }
    },
    onShowSharePopover() {
      if (!this.posterUrl) {
        this.$refs.poster.checkLoad();
      }
    },
    handleShareBack() {
      this.selectShare = {
        type: "",
      };
    },
    // stopLoading() {
    //   console.log("stopLoading--4");
    //   this.pageLoading = false;
    // },
    onEndClass(event, params) {
      setTimeout(() => {
        this.$refs.liveOverview.openDialog({
          lessonId: params.lessonId,
          courseId: params.courseId,
        });
      }, 100);
    },
    createLessonAndRoom(unit_id) {
      if (!unit_id) return;
      let liveDuration = this.form.live_duration || 60;
      let startTime = getNextFiveMinutes() / 1000;
      let endTime = startTime + 1 * liveDuration * 60;
      let params = {
        lesson_name: this.form.lesson_name,
        lesson_type: 2,
        live_start_time: startTime,
        live_end_time: endTime,
        teacher_id: this.user.user_id,
        assistant_teacher_id: "",
        course_id: this.course_id,
        unit_id: unit_id,
        first_join_time: 5,
      };
      createLesson(params).then((res) => {
        if (res.code === 1) {
          // 关闭创建直播课时
          this.createRoomVisible = false;
          let data = res.data || {};
          data.lesson_id = data.id;
          data.course_type = this.courseInfo.course_type;
          this.$refs.liveMode.openDialog(res.data || {});
          // 重新获取课程信息
          this.apiGetCourseInfo();
        } else if ([4444, 6666].includes(res.code)) {
          this.handleCancel();
          if (res.code === 4444) {
            this.$showErrorPage();
          } else {
            this.$showErrorPage({
              tips: "课程不存在",
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // createRooming(status) {
    //   this.pageLoading = status;
    // },
    handleSuccess(obj) {
      this.apiGetTeacherToken(obj);
    },
    apiGetTeacherToken(obj) {
      this.$saasLoadingShow();
      // this.pageLoading = true;
      let params = {
        course_id: obj.course_id,
        lesson_id: obj.lesson_id,
        is_teacher: this.user.is_teacher,
      };
      getTeacherToken(params).then((res) => {
        if (res.code === 1) {
          let {
            room_id = "",
            token = "",
            user_id = "",
            risk_control_switch,
            risk_control_config = {},
            is_lesson_teacher,
            is_lesson_assistant,
          } = res.data;
          let { course_id = "", lesson_id = "" } = obj;
          const disableRecord =
            risk_control_switch === 1 &&
            risk_control_config.recording_screen_switch === 1
              ? 1
              : 0;
          let liveParams = {
            classid: room_id,
            userid: user_id,
            courseid: course_id,
            lessonid: lesson_id,
            token: token,
            isTeacher: is_lesson_teacher,
            disableRecord,
            mode: obj.mode,
            isNewLive: obj.is_new_live,
            isAssistant: is_lesson_assistant,
          };
          // this.pageLoading = false;
          joinLiveRoom(liveParams);
        } else {
          this.$saasLoadingClose();
          // this.pageLoading = false;
          this.$message.error(res.message);
        }
      });
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (!this.courseInfo?.unit_list?.length) {
            // 没有单元
            let params = {
              course_id: this.course_id,
              id: 0,
              unit_name: "新建单元",
            };
            createUnit(params).then((res) => {
              if (res.code === 1) {
                this.createLessonAndRoom(res.data?.id);
              } else if ([4444, 6666].includes(res.code)) {
                this.handleCancel();
                if (res.code === 4444) {
                  this.$showErrorPage();
                } else {
                  this.$showErrorPage({
                    tips: "课程不存在",
                  });
                }
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            //有单元
            let length = this.courseInfo.unit_list.length;
            let unit_id = this.courseInfo.unit_list[length - 1].id;
            this.createLessonAndRoom(unit_id);
          }
        }
      });
    },
    handleCancel() {
      this.form = {
        lesson_name: "",
        live_duration: 60,
      };
      this.createRoomVisible = false;
    },
    async createRoom() {
      let res = await checkLiveTime();
      if (res.code === 1) {
        if (!res.data) {
          // 正常创建直播
          if (checkPermission("action:course:lesson:add")) {
            this.createRoomVisible = true;
          } else {
            this.$message.error(
              `您没有在课程【${this.courseInfo.course_name}】内的课时管理权限，不能创建直播。`
            );
          }
        } else if (res.data && res.data.mode) {
          // 代表该课程下有正在直播的课时
          this.$confirm("当前账号正在直播中，不能发起新的直播。", "提示", {
            center: true,
            showCancelButton: false,
            confirmButtonText: "前往已有直播",
            customClass: "saas-confirm-message",
            confirmButtonClass: "confirm-btn",
            closeOnClickModal: false,
          })
            .then(() => {
              res.data.lesson_id = res.data.id;
              this.apiGetTeacherToken(res.data);
            })
            .catch(() => {});
        } else if (res.data && res.data.mode === 0) {
          // 代表该课程下有最近30分钟内要开始的直播
          let startTime = moment(res.data.live_start_time * 1000).format(
            "HH:mm"
          );
          let endTime = moment(res.data.live_end_time * 1000).format("HH:mm");
          this.$confirm(
            `<div>该课程下您今天有场直播，要现在开始直播吗？<div><div>${res.data.lesson_name}<div><div>今天${startTime}-${endTime}<div>`,
            "提示",
            {
              cancelButtonText: "取消",
              confirmButtonText: "开始直播",
              customClass: "saas-confirm-message",
              confirmButtonClass: "confirm-btn",
              cancelButtonClass: "cancel-btn",
              closeOnClickModal: false,
              dangerouslyUseHTMLString: true,
            }
          )
            .then(() => {
              const lesson = {
                ...res.data,
                lesson_id: res.data.id,
                course_type: this.courseInfo.course_type,
              };
              this.$refs.liveMode.openDialog(lesson);
            })
            .catch(() => {});
        }
        // if (res.data && res.data.mode) {
        //   this.$confirm("当前账号正在直播中，不能发起新的直播。", "提示", {
        //     center: true,
        //     showCancelButton: false,
        //     confirmButtonText: "前往已有直播",
        //     customClass: "saas-confirm-message",
        //     confirmButtonClass: "confirm-btn",
        //     closeOnClickModal: false,
        //   })
        //     .then(() => {
        //       res.data.lesson_id = res.data.id;
        //       this.apiGetTeacherToken(res.data);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.haveWillBeginLesson = false;
        //   if (this.courseInfo?.unit_list?.length) {
        //     for (
        //       let index = 0;
        //       index < this.courseInfo.unit_list.length;
        //       index++
        //     ) {
        //       const unit = this.courseInfo.unit_list[index];
        //       if (unit?.lesson_list?.length) {
        //         for (let i = 0; i < unit.lesson_list.length; i++) {
        //           const lesson = unit.lesson_list[i];
        //           console.log(lesson, "lesson");
        //           let { mode, live_start_time, live_end_time, lesson_name } =
        //             lesson;
        //           let now = new Date().getTime();
        //           live_start_time = live_start_time * 1000;
        //           live_end_time = live_end_time * 1000;
        //           let start = live_start_time - 30 * 60 * 1000;
        //           if (!(now > live_end_time) && !(now < start) && !mode) {
        //             this.haveWillBeginLesson = true;
        //             let startTime = moment(live_start_time).format("HH:mm");
        //             let endTime = moment(live_end_time).format("HH:mm");
        //             this.$confirm(
        //               `<div>该课程下您今天有场直播，要现在开始直播吗？<div><div>${lesson_name}<div><div>今天${startTime}-${endTime}<div>`,
        //               "提示",
        //               {
        //                 cancelButtonText: "取消",
        //                 confirmButtonText: "开始直播",
        //                 customClass: "saas-confirm-message",
        //                 confirmButtonClass: "confirm-btn",
        //                 cancelButtonClass: "cancel-btn",
        //                 closeOnClickModal: false,
        //                 dangerouslyUseHTMLString: true,
        //               }
        //             )
        //               .then(() => {
        //                 lesson.lesson_id = lesson.id;
        //                 lesson.course_type = this.courseInfo.course_type;
        //                 this.$refs.liveMode.openDialog(lesson);
        //               })
        //               .catch(() => {});
        //             break;
        //           }
        //         }
        //       }
        //       if (this.haveWillBeginLesson) {
        //         break;
        //       }
        //     }
        //     if (!this.haveWillBeginLesson) {
        //       if (checkPermission("action:course:lesson:add")) {
        //         this.createRoomVisible = true;
        //       } else {
        //         this.$message.error(
        //           `您没有在课程【${this.courseInfo.course_name}】内的课时管理权限，不能创建直播。`
        //         );
        //       }
        //     }
        //   } else {
        //     if (checkPermission("action:course:lesson:add")) {
        //       this.createRoomVisible = true;
        //     } else {
        //       this.$message.error(
        //         `您没有在课程【${this.courseInfo.course_name}】内的课时管理权限，不能创建直播。`
        //       );
        //     }
        //   }
        // }
      } else {
        this.$message.error(res.message);
      }
    },
    apiGetCourseInfo() {
      getCourseInfo({ course_id: this.course_id }).then((res) => {
        if (res.code === 1) {
          this.localSavePage(res.data);
          // 计算课时数-直播课状态处理
          this.courseInfo = this.handleCourseInfoData(res.data || {});
          this.havePrivateLesson();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    goReplay() {},
    goLiveRoom() {},
  },
  computed: {
    ...mapGetters(["user"]),
  },
  components: {
    File,
    LessonList,
    Dialog,
    LiveModeDialog,
    LiveOverview,
    CreateQrCode,
    Poster,
  },
};
</script>

<style lang="scss" scoped>
.teacher-course-detail {
  display: flex;
  flex-direction: column;
  ::v-deep .lesson-form {
    .el-form-item {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-form-item__label {
      font-size: 14px;
      color: #515350;
      line-height: 22px;
      margin-bottom: 8px;
      padding: 0;
    }
    .el-input input {
      background: $saas-bg-color;
      border-radius: 8px;
    }
    .el-input__inner {
      height: 38px;
      border: none;
      font-size: 14px;
      color: $saas-text-color;
    }
    .el-input__inner::placeholder {
      font-size: 14px;
      color: #747573;
    }
    // 选择框样式
    .el-select {
      width: 100%;
      .el-input__inner {
        height: 38px;
        background: $saas-bg-color;
        border: none;
        border-radius: 8px;
        font-size: 14px;
        color: $saas-text-color;
      }
      .el-input__inner::placeholder {
        font-size: 14px;
        color: #747573;
      }
      .el-input__suffix {
        right: 10px;
      }
    }
  }
  .create-room-dialog ::v-deep .el-dialog {
    height: 300px;
  }
  .create-room-dialog {
    padding-bottom: 90px;
    .dialog-footer {
      position: absolute;
      left: 50%;
      bottom: 24px;
      transform: translateX(-50%);
      text-align: center;
    }
    .cancel-btn {
      min-width: 78px;
      height: 36px;
      background: $saas-bg-color;
      border-radius: 8px;
      font-size: 14px;
      color: $saas-text-color;
      padding: 0 18px;
      border: none;
    }
    .submit-btn {
      min-width: 78px;
      height: 36px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      font-size: 14px;
      color: #ffffff;
      padding: 0 18px;
      border: none;
      border-radius: 8px;
      margin-left: 16px;
    }
  }
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    background: #ffffff;
    border-radius: 16px;
    height: 46px;
    padding-left: 35px;
  }
  ::v-deep .el-breadcrumb__inner.is-link {
    font-weight: 600;
    font-size: 16px;
    color: $saas-text-color;
    line-height: 1;
    padding: 5px;
  }
  ::v-deep .el-breadcrumb__inner {
    font-weight: 400;
    font-size: 16px;
    color: $plain-text-color;
    line-height: 1;
    padding: 5px;
  }
  ::v-deep .el-breadcrumb__item {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-breadcrumb__separator {
    margin: 0 9px;
    color: #efefef;
    font-size: 10px;
    line-height: 1;
    font-weight: 600;
  }
  .page-cont-wrap {
    background: #fff;
    border-radius: 24px;
    padding: 16px;
    margin-bottom: 30px;
  }
  // 课程信息
  .course-crad {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
    .cover-wrap {
      width: 298px;
      height: 168px;
      border-radius: 16px;
      overflow: hidden;
      margin-right: 16px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .course-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 0;
      height: 168px;
      .name-wrap {
        display: flex;
      }
      .share-icon {
        width: 18px;
        height: 28px;
        margin-left: 6px;
      }
      .share-icon img {
        height: 16px;
        width: 16px;
      }
      .name {
        margin-bottom: 6px;
        font-weight: 500;
        font-size: 18px;
        color: $saas-text-color;
        line-height: 28px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
      .lesson-num {
        font-weight: 400;
        font-size: 14px;
        color: #747573;
        line-height: 20px;
      }
    }
    .create-room-btn {
      width: 112px;
      height: 46px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 12px;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      line-height: 25px;
    }
  }
  .separator-hr {
    width: 1010px;
    height: 1px;
    background: #efefef;
    border-radius: 12px;
    margin: 0 auto;
  }

  .tabs-wrap {
    display: flex;
    padding: 7px 0 14px 22px;
    li {
      font-weight: 400;
      font-size: 16px;
      color: $plain-text-color;
      line-height: 22px;
      padding: 6px;
      margin-right: 43px;
      cursor: pointer;
    }
    .active {
      position: relative;
      font-weight: 600;
      color: $saas-text-color;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 16px;
        height: 3px;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        border-radius: 2px;
      }
    }
  }

  .lesson-list-wrap {
    min-height: 400px;
  }
}
// 客户端
.electron-teacher-course-detail.teacher-course-detail {
  .page-cont-wrap {
    padding: 12px;
    margin-bottom: 30px;
  }
  // 课程信息
  .course-crad {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    .cover-wrap {
      width: 200px;
      height: 110px;
      margin-right: 10px;
      border-radius: 16px;
    }
    .course-info {
      height: 110px;
      .name {
        margin-bottom: 3px;
        font-size: 16px;
        line-height: 28px;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }
      .lesson-num {
        margin-bottom: 4px;
      }
      .time,
      .lesson-num {
        font-size: 12px;
        line-height: 14px;
      }
    }
    .course-status {
      span {
        width: 51px;
        height: 24px;
        border-radius: 6px;
        font-size: 12px;
        line-height: 20px;
      }
    }

    .create-room-btn {
      width: 100px;
      height: 38px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 8px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }

  .separator-hr {
    width: 100%;
  }

  .tabs-wrap {
    display: flex;
    padding: 5px 0 7px 35px;
    li {
      font-size: 14px;
      line-height: 20px;
      padding: 6px;
      margin-right: 40px;
    }
  }
}
.share-box {
  .share-list {
    padding: 9px 8px 5px 8px;
    .share-item {
      width: 174px;
      height: 38px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        background: #f6f8fc;
      }
      img {
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-right: 7px;
      }
      span {
        font-size: 14px;
        color: #0d1400;
        line-height: 20px;
      }
      &.copy {
      }
    }
    .divider {
      width: 173px;
      height: 1px;
      background: #f2f3f5;
      margin: 7px 0 3px 0;
    }
  }
  .share-content {
    width: 190px;
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 14px;
      margin-left: 19px;
      img {
        cursor: pointer;
        width: 6px;
        height: 9px;
        margin-right: 6px;
      }
      span {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
    }
    .qrcode-box {
      margin-top: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tips {
      padding: 0 13px 21px 16px;
      margin-top: 22px;
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      text-align: center;
    }
  }
}
</style>
<style>
.el-loading-spinner {
  font-size: 40px !important;
  z-index: 99;
}
.el-loading-spinner .el-loading-text {
  font-size: 15px !important;
  font-weight: 700 !important;
}
.share-popover {
  padding: 0;
  border-radius: 12px;
}
</style>
